// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { DropdownHandlersContext, DropdownPropsContext } from './../../context'

import styles from './Anchor.module.scss'

export const Anchor = ({
  ariaLabel,
  children,
  isDisabled = false,
  className = undefined,
}) => {
  const { onToggle } = React.useContext(DropdownHandlersContext)
  const { reference } = React.useContext(DropdownPropsContext)

  return (
    <button
      aria-label={ariaLabel}
      className={cx(styles.anchor, { [className]: Boolean(className) })}
      ref={reference}
      onClick={onToggle}
      disabled={isDisabled}
    >
      <span className={styles.content}>{children}</span>
    </button>
  )
}
